import React from 'react'
import { Modal } from 'antd'
import Button from '../Button'
import { FiCheckCircle } from 'react-icons/fi'
import { BiErrorCircle } from 'react-icons/bi'
import { IconContext } from 'react-icons'
import { isMobile, isTablet, isDesktop } from 'react-device-detect'

interface ProceedModalProps {
  isVisible: boolean
  onProceed: () => void
  onCancel: () => void
  title: string
  description: string
  btn1?: string
  btn2: string
  type?: string
}

const MessageModal = ({ isVisible, onProceed, onCancel, title, description, type, btn1, btn2 }: ProceedModalProps) => {
  return (
    <>
      <Modal
        width={`${(isMobile || isTablet) && !isDesktop ? '90vw' : '50vw'}`}
        open={isVisible}
        centered
        footer={null}
        closable={false}
      >
        <div className="flex flex-col items-center py-4 md:py-4">
          <div className="text-5xl">
            {type === 'success' && (
              <IconContext.Provider value={{ color: 'green' }}>
                <FiCheckCircle />
              </IconContext.Provider>
            )}
            {type === 'error' && (
              <IconContext.Provider value={{ color: 'red' }}>
                <BiErrorCircle />
              </IconContext.Provider>
            )}
          </div>
          <div className="my-4 md:my-0">
            <div className="mt-4 text-center text-3xl font-semibold md:mt-4 md:text-4xl">{title}</div>
            <div className="my-5 text-center text-xl md:text-2xl">{description}</div>
          </div>

          <div className="flex w-full justify-center px-10 md:p-10 md:px-0">
            <div className="flex w-full flex-col items-center">
              <Button btnName={btn2} btnType={'button'} onClickHandler={onProceed} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default MessageModal
